// Permission logic for show-structure feature
import { getRoleById } from '../auth/permissions';
import type { ProjectMember, Role } from '../auth/types';

const SCRIPT_EDITOR_ROLE_TEMPLATE_IDS = new Set([
    'owner',
    'stage-manager',
    'assistant-stage-manager',
]);

export const canAccess = () => true;

export function canAccessScriptEditor(
    member: ProjectMember | null | undefined,
    roles: Role[]
): boolean {
    if (!member || member.status !== 'active') {
        return false;
    }

    const role = getRoleById(roles, member.roleId);
    if (!role) {
        return false;
    }

    const roleTemplateId = role.sourceTemplateId || role.id;
    return SCRIPT_EDITOR_ROLE_TEMPLATE_IDS.has(roleTemplateId);
}













